




































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import CompanySelection from '@/components/CompanySelection.vue';
import deck from '@/store/modules/deck';
import user from '@/store/modules/user';

@Component({
    components: {CompanySelection},
})
export default class TypedPages extends Vue {
    template: string = '';
    company: any = {};

    mounted() {
        this.loadCompany();
    }

    async loadCompany() {
        this.company = null;

        if (deck.OrgNr === '00' || deck.OrgNr === '') {
            return;
        }

        const c = await user.getCompany(deck.OrgNr);
        if (!c) {
            return;
        }

        this.company = {
            value: c.OrgNr,
            label: c.Name,
            dateTo: c.DateTo,
            SieAggVersion: deck.SieAggVersion,
        };
    }

    companyUpdated(company: any) {
        this.$emit('orgNr', company ? company.value : '');
    }

    sourceUpdated(source: any) {
        this.$emit('sieAggVersion', source ? source.id : '');
    }

    @Watch('template')
    onTemplateChanged(val: string) {
        this.$emit('template', val);
        if (this.requiresCompany(val)) {
            this.$emit('requiresCompany', true);
        } else {
            this.company = {};
            this.$emit('orgNr', '');
            this.$emit('sieAggVersion', '');
            this.$emit('requiresCompany', false);
        }
    }

    requiresCompany(type: string) {
        switch (type) {
            case 'profitlossOverview':
            case 'balanceOverview':
            case 'liquidityOverview':
                return true;
            default:
                return false;
        }
    }

    get brand() {
        return process.env.VUE_APP_BRAND;
    }
}
